// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

export default function useServiceInterventions() {
    const { data: interventionGroups = [] } = useApiSWRReference(
        '/service-intervention-groups'
    )

    const interventions = interventionGroups.flatMap((group) => {
        return group.service_interventions.map((intervention) => {
            return {
                ...intervention,
                group_id: group.id,
                group_name: group.name,
            }
        })
    })

    return { interventionGroups, interventions }
}
